skrilla.controller('loginModalCtrl', function ($scope, searchService, $window, $location, adminService, modalService, srefService) {
    $scope.login = function () {
        searchService.login($scope.loginDetails, function(response) {
            if (response.status == 200 || response.status == 204) {
                var path = $location.search().returnUrl;
                $window.localStorage.token = "Bearer " + response.data.token;
                adminService.getAdmin(true);
                //adminService.getAdmin(true);
                modalService.dismissAll();

                if (response.data.mfa == 'NONE') {
                  modalService.openModal("views/totp/totpModal.html", true, 'lg', true, true)
                }
            }
        }, function(response) {
            delete $window.localStorage.token;
            delete $window.localStorage.fbToken;

            if (response.status === 403 &&
              response.data.errors &&
              response.data.errors[0].messageTemplate === 'password.reset.required') {
                modalService.dismissAll();
                srefService.go("changePassword");
            }
        });
    }
    $scope.btnPress = function (keyEvent) {
        if (keyEvent.which === 13)
            $scope.login();
    }
});

